module.exports = __webpack_public_path__ + "static/media/Ubuntu-MediumItalic.89af35d9.ttf";